"use strict";

import GeometryCollection from "ol/geom/GeometryCollection";
import Geometry from 'ol/geom/Geometry';

/**
 * @classdesc
 * Wrapperklasse für eine OpenLayers Geometrie-Collection.
 *
 * @class
 * @extends gc.gis.geom.GCGeometryCollection
 * @memberof gc.gis.geom
 * @author Christian Schmidt <c.schmidt@brain-scc.de>
 *
 * @param {ol.geom.GeometryCollection} opt_collection gewrappte Geometrie-Collection-Instanz
 */
gc.gis.geom.OLGeometryCollection = function(opt_collection)
{
    if (!opt_collection)
    {
	    opt_collection = new GeometryCollection([]);
    }

    gc.gis.assert.isInstance(opt_collection, GeometryCollection);
    gc.gis.geom.GCGeometryCollection.call(this, opt_collection);

    // mixin erstellen
    const source = gc.gis.geom.OLGeometry.prototype;
    for (let prop in source) {
        if (source.hasOwnProperty(prop)) {
            this[prop] = source[prop];
        }
    }

    // die OL-Geometrien müssen einzeln gewrappt und neu gesetzt werden (unschön)
    const geoms = [],
        ol_geoms = opt_collection.getGeometries(),
        geometryFactory = new gc.gis.geom.OLGeometryFactory();

    ol_geoms.forEach(function (g) {
        geoms.push(geometryFactory.createGeometry(g))
    });
    this.setGeometries(geoms);
};
gc.gis.geom.OLGeometryCollection.prototype = Object.create(gc.gis.geom.GCGeometryCollection.prototype);

/**
 * @inheritDoc
 */
gc.gis.geom.OLGeometryCollection.prototype._addGeometryImpl = function (geometry)
{
	gc.gis.assert.isInstance(geometry, Geometry);
    //this._geom.getGeometries().push(geometry);        // !! liefert einen Klone des Array
	//this._geom.getGeometriesArray().push(geometry);   // steht leider nur in OL-Debug Version zur Verfügung

    // Geometrien setzen (ggf. überarbeiten, falls OL eine addGeometry-Methode für eine GeometryCollection anbietet)
    const ol_geoms = [];
    let i, ii;
    for (i = 0, ii = this._geometries.length; i < ii; i++)
    {
        ol_geoms.push(this._geometries[i].getImpl());
    }
	this._geom.setGeometries(ol_geoms);
};

/**
 * @inheritDoc
 */
gc.gis.geom.OLGeometryCollection.prototype._resetGeometryImpl = function ()
{
    this._geom.setGeometries([]);
};